import { MenuItem, Menu } from '@mui/material';
import React from 'react';
import './Card.css';

export default function DropdownMenuComponent({ options, card }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      className="position-absolute"
      style={{ right: 10, top: '15px', width: '20px' }}>
      <div
        style={{ cursor: 'pointer' }}
        className="threeDotIcon"
        id="demo-positioned-button"
        aria-controls={open ? 'demo-positioned-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={(e) => {
          handleClick(e);
        }}>
        <img src={require('../assets/img/dropDownOption.png')} />
      </div>{' '}
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}>
        {options?.map((option, index) => (
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              option?.action();
              handleClose();
            }}
            key={option + index}>
            {option?.component} <span className="ms-2">{option?.name}</span>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
